import React from 'react'
import { Tooltip } from 'antd'
import styles from './style.module.scss'

const EmailWithTooltip = ({ email, className = '', style }) => {
  const displayEmail = email || '—'

  return (
    <Tooltip title={email || undefined}>
      <span className={`${styles.email} ${className}`} style={style}>
        {displayEmail}
      </span>
    </Tooltip>
  )
}

export default EmailWithTooltip
